module.exports = __webpack_public_path__ + "static/media/black_label_mobile.6cbe86ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/backgrounds/black_label_mobile.jpg
// module id = 524
// module chunks = 0